import { BrandRegionCode } from "core/entities";
import { useRegion } from "./useRegion";
import { getBrand } from "../utils/getBrand";

export function useBrandRegionCode(): BrandRegionCode {
  const { brandCode } = getBrand();
  const region = useRegion();
  return `${brandCode}${region}` as BrandRegionCode;
}
